import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { AnnouncementDetailState } from 'types/announcements';
import { normalizeAnnouncement } from 'redux/slices/announcements/announcementsSlice';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { ID } from 'types/common';

const initialState: AnnouncementDetailState = {
    details: null,
    loading: false,
    error: false,
};

export const fetchAnnouncementDetails = createAsyncThunkWrapper<any, ID>('AnnouncementDetails/fetchAnnouncementDetails', async (id: ID) => {
    const res: any = await client.get(`/notification/getNotificationById/${id}`);
    return normalizeAnnouncement(res.notification);
});

const announcementDetailsSlice = createSlice({
    name: 'announcementDetails',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAnnouncementDetails.pending, (state) => {
            state.loading = true;
            state.error = false;
        });
        builder.addCase(fetchAnnouncementDetails.fulfilled, (state, action) => {
            state.loading = false;
            const { payload } = action || {};
            if (!payload) return;
            state.details = payload;
        });
        builder.addCase(fetchAnnouncementDetails.rejected, (state) => {
            state.loading = false;
            state.error = false;
        });
    },
});

export default announcementDetailsSlice.reducer;
